import { useTheme } from '@kitopi-com/customer-auth';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { BiError } from 'react-icons/bi';
import type { WifiTranslationKeys } from '../../types/Translation';
import { ErrorDisplayContainer, ErrorDisplayMessage } from './ErrorDisplay.styles';

interface ErrorDisplayProps {
  message?: string;
  errorKey?: string;
  iconSize?: number;
  showIcon?: boolean;
  icon?: ReactNode;
}

export const ErrorDisplay = ({
  message,
  errorKey,
  iconSize = 24,
  showIcon = true,
  icon,
}: ErrorDisplayProps) => {
  const { colors } = useTheme();
  const { t } = useTranslation('wifi');

  // Domyślnie użyj errorKey jeśli nie ma message
  const displayMessage =
    message || (errorKey ? t(errorKey as WifiTranslationKeys) : t('authSignInError'));

  // Renderuj customową ikonę lub domyślną BiError
  const renderIcon = () => {
    if (!showIcon) return null;

    if (icon) {
      return icon;
    }

    return <BiError size={iconSize} color={colors?.kitopiColors.kitopiWhite ?? '#FFFFFF'} />;
  };

  return (
    <ErrorDisplayContainer>
      {renderIcon()}
      <ErrorDisplayMessage>{displayMessage}</ErrorDisplayMessage>
    </ErrorDisplayContainer>
  );
};
